import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { useGet, usePost } from 'components';
import { ErrorPopup } from 'components';
import { getProductEditModel } from './productEditFormModel';
import { Redirect, Link } from "react-router-dom";
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';

import { ImageSelector } from './imageSelector';
import { ImageSelectorSingle } from './imageSelectorSingle';
//import { MediaSelector } from './mediaSelector';
import { VariantAttributes } from './variantAttribute/variantAttributeList';
import { Variants } from './variantList/variantList';
import { getVariants } from './variantList/variantModel';
import { createGroup } from "./productEditFormModel";
import { StoreSelector } from "./storeSelector";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaGripLines, FaRegEyeSlash, FaRegEye, FaTrash } from "react-icons/fa";

import utils from 'utils';

export function ProductEdit(props) {
  const { query } = useRouter();
  const get = useGet();

  const productCode = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + `/api/productAdmin/getProduct/${productCode}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  const model = getProductEditModel(data);
  console.log(model)

  return <ProductEditForm model={model} data={data} productCode={productCode} />
}


export function ProductEditForm({ model, data, productCode }) {
  const form = useForm(model, {});
  const post = usePost();

  const [variantAttrs, setVariantAttrs] = React.useState(data.variantAttributes || []);
  const [variants, setVariants] = React.useState(data.variants || []);
  const [action, setAction] = React.useState('save');
  const [currentTab, setCurrentTab] = React.useState(null);

  React.useEffect(() => {
    setVariants([...getVariants(variantAttrs, variants)])
    // eslint-disable-next-line
  }, [variantAttrs]);

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const formValue = form.getValue();
      const value = {
        ...formValue,
        orgProductCode: productCode,
        variantAttributes: variantAttrs,
        variants: variants,
        // Convert relatedProducts from string to array
        relatedProducts: formValue.relatedProducts
          ? formValue.relatedProducts.split('\n').filter(x => x.trim() !== '')
          : []
      };
      post.send(env.apiBase + "/api/productAdmin/saveProduct", value);
    })
  }

  function remove(e) {
    if (!window.confirm('Delete this??')) return;
    //post.send(env.apiBase + "/api/productAdmin/removeProduct", { productId: productCode });
    setAction('remove');
    post.send(env.apiBase + "/api/productadmin/removepermanentlyproduct", { productId: productCode });
  }

  function suggestUrl() {
    const value = form.getValue();
    const productUrl = form.findControl('productSlug');
    productUrl.value = utils.url.getSlug(value.productName);
    form.reset()
  }

  if (post.status === 'done') {
    if (action === 'save') window.location.reload();
    return <Redirect to="/admin/products" />
  }

  const tabs = [
    { id: "wheretobuy", title: "Where to buy", tabView: WhereToBuyTab },
    { id: "details", title: "Details", tabView: DetailsTab },
    { id: "styleTips", title: "Style Tips", tabView: StyleTipsTab },
    { id: "photos", title: "Photos", tabView: PhotoTab },
    { id: "related", title: "Related", tabView: RelatedTab },
  ];

  const currentTabId = currentTab || tabs[0].id;

  function showTab(tabId) {
    setCurrentTab(tabId);
  }

  const productUrlAU = data.productUrl ? env.baseUrl + data.productUrl : `${env.baseUrl}/ecm/products/${data.productSlug}`;

  const formVal = form.getValue();

  return (
    <div className="editor productEditor">
      <div className="productEditor__links">
        {formVal.productStatusAU !== 99 && <a href={productUrlAU} rel="noopener noreferrer" target="_blank">Product Page</a>}
      </div>
      <h1>Product Edit</h1>

      <section>
        <div className="row">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12">{render('productName')}</div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('productSlug')}
                <div style={{ textAlign: 'right' }}>
                  <button type="button" className="btn btn-outline-info btn-sm" onClick={suggestUrl}>Suggest URL from product name</button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('productStatus')}</div>
              <div className="col-md-6">{render('productCode')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('productType')}</div>
              <div className="col-md-6">{render('taxCode')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('price')}</div>
              {/* <div className="col-md-6">{render('retailPrice')}</div> */}
            </div>
            <div className="row">
              <div className="col-md-6">{render('shippingFeeType')}</div>
              <div className="col-md-6">{render('shippingFee')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('youtubeCode')}</div>
              <div className="col-md-6">{render('categoryBanner')}</div>
              <div className="col-md-6">{render('youtubeCodePortrait1')}</div>
              <div className="col-md-6">{render('youtubeCodePortrait2')}</div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('categoryIds')}</div>
            </div>
            <div className="row">
              <div className="col-md-6">{render('shortDesc')}<WordCounter form={form} field="shortDesc" forMeta={false} /></div>
              <div className="col-md-6">{render('metaDesc')}<WordCounter form={form} field="metaDesc" forMeta={true} /></div>
            </div>
            <div className="row">
              <div className="col-md-12">{render('description')}</div>
            </div>
          </div>
          <div className="col-md-6">
            {/* <label className="label">Product Images</label>
            <ImageSelector form={form} data={data} fieldName="productImages" />

            <hr /> */}
            <h3>Variant Attributes</h3>
            <VariantAttributes form={form} data={data} variantAttrs={variantAttrs} setVariantAttrs={setVariantAttrs} />
            <hr />
            <h3 style={{ marginTop: '1rem' }}>Variants</h3>
            <Variants form={form} data={data} variants={variants} setVariants={setVariants} variantAttrs={variantAttrs} />
          </div>
        </div>

        <div className="row" style={{ marginTop: "3rem" }}>
          <div className="col-12">
            <div className="productEditor__tabs">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`tab ${(currentTabId === tab.id && "selected") || ""
                    }`}
                  onClick={(e) => showTab(tab.id)}
                >
                  {tab.title}
                </div>
              ))}
            </div>

            <div className="productEditor__tabContents">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`tabContent ${(currentTabId === tab.id && "selected") || ""
                    }`}
                >
                  <tab.tabView form={form} data={data} />
                </div>
              ))}
            </div>
          </div>

          {/* <div className="col-md-6">
            <div className="row">
              <div className="col-12">{render('details')}</div>
            </div>
            
           
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-12">{render('styleTips')}</div>
            </div>
            <div className="row">
              <div className="col-12">{render('specifications')}</div>
            </div>
            <div className="row">
              <div className="col-12">{render('seeMore')}</div>
            </div>
          </div> */}
        </div>


        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Save</Button>
            {/* {productCode &&
              <Button onClick={remove} status={form.status} btnStyle="outline-primary">Permanently Delete</Button>} */}
            <Link className="btn btn-outline-dark" to="/admin/products">Cancel</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function WhereToBuyTab({ form, data }) {
  const section = form.findControl("whereToBuySection");
  const addOptions = [{ name: "Html", itemTypeCode: "html" }];
  return (
    <>
      {/* <EditorPanel
        form={form}
        section={section}
        addOptions={addOptions}
        data={data}
      /> */}

      <h2>Shops</h2>
      <StoreSelector form={form} data={data} fieldName="productStores" />
    </>
  );
}

function DetailsTab({ form, data }) {
  const section = form.findControl("detailSection");
  const addOptions = [{ name: "Html", itemTypeCode: "html" }];
  return (
    <EditorPanel
      form={form}
      section={section}
      addOptions={addOptions}
      data={data}
      tabType={"detailSection"}
    />
  );
}

function StyleTipsTab({ form, data }) {
  const section = form.findControl("styleTipsSection");
  const addOptions = [
    { name: "Html", itemTypeCode: "html" },
    { name: "Video", itemTypeCode: "video" },
    { name: "Portrait Video", itemTypeCode: "portraitVideo" }
  ];
  return (
    <EditorPanel
      form={form}
      section={section}
      addOptions={addOptions}
      data={data}
      tabType={"styleTipsSection"}
    />
  );
}

function PhotoTab({ form, data }) {
  return (
    <>
      <ImageSelector form={form} data={data} fieldName="productImages" />
    </>
  );
}

function RelatedTab({ form, data }) {
  const render = (name) => form.renderControl(name);
  return (
    <div className="row">
      <div className="col-md-6">{render("relatedProducts")}</div>
      <div className="col-md-6">
        {/* <div className="form-group">
          <label className="label">
            Reference - Related Products from the current site
          </label>
          <pre>{data.migRelatedProducts?.join("\n")}</pre>
        </div> */}
      </div>
    </div>
  );
}

function EditorPanel({ form, section, addOptions, data, tabType }) {
  function onDragEnd(result) {
    //console.log(result)

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    //console.log(JSON.stringify(section))
    if (section?.controls) {
      section.controls = utils.array.moveItem(
        Array.from(section.controls || []),
        result.source.index,
        result.destination.index
      );
    }
    // console.log(JSON.stringify(section))
    // console.log(JSON.stringify(form.model))
    form.reset();
  }

  function removed(id) {
    console.log(id);
    if (section?.controls) {
      section.controls = section.controls.filter((x) => x.id !== id);
      form.reset();
    }
  }

  function activateAll() {
    if (section?.controls) {
      section.controls.forEach((item) => {
        item.find("itemStatus").value = 0;
      });
      form.reset();
    }
  }

  function deactivateAll() {
    if (section?.controls) {
      section.controls.forEach((item) => {
        item.find("itemStatus").value = 99;
      });
      form.reset();
    }
  }

  function addItem(e) {
    console.log(e.target.value);
    const itemTypeCode = e.target.value;
    let itemValue = "";
    if (itemTypeCode === "video") {
      itemValue = JSON.stringify({ videoUrl: "", title: "", desc: "" });
    } else if (itemTypeCode === "qa") {
      itemValue = JSON.stringify({ question: "", answer: "" });
    } else if (itemTypeCode === "spec") {
      itemValue = JSON.stringify({ category: "L", label: "", text: "" });
    } else if (itemTypeCode === "html") {
      itemValue = ""; // For HTML items, itemValue is stored directly as HTML string
    } else if (itemTypeCode === "link") {
      itemValue = JSON.stringify({
        linkType: "auto",
        title: "",
        url: "",
        imageUrl: "",
        desc: "",
        instagramEmbed: "",
      });
    } else if (itemTypeCode === "weblink") {
      itemValue = JSON.stringify({ linkType: "auto", title: "", url: "" });
    } else if (itemTypeCode === "portraitVideo") {
      itemValue = JSON.stringify({ videoUrl: "", title: "", desc: "" });
    }

    const group = createGroup({
      itemTypeCode: itemTypeCode,
      itemValue: itemValue,
      itemStatus: 0,
    });
    console.log(group);
    if (section?.controls) {
      section.controls.push(group);
      form.reset();
      console.log(form);
    }

  }

  return (
    <div className="editSection">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`editSection__list ${snapshot.isDraggingOver ? "editSection__list--dragging" : ""
                }`}
            // style={getListStyle(snapshot.isDraggingOver)}
            >
              {(section?.controls || []).map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={provided.draggableProps.style}
                      className={`editSection__item ${snapshot.isDragging ? "editSection__item--dragging" : ""
                        }`}
                    >
                      <ItemEditor
                        form={form}
                        item={item}
                        provided={provided}
                        removed={removed}
                        data={data}
                        tabType={tabType}
                        index={index}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <div className="editSection__actions">
        <span>For all items in this section,</span>
        <button className="btn btn-warning" onClick={activateAll}>
          Activate all{" "}
        </button>
        <button className="btn btn-warning" onClick={deactivateAll}>
          Deactivate all{" "}
        </button>
        {/* <button className="btn btn-warning" onClick={deleteAll}>
          Delete all{" "}
        </button> */}
        {addOptions && (
          <span>
            <select className="form-control" onChange={addItem} value={""}>
              <option value="">Add Item</option>
              {addOptions.map((x, index) => (
                <option value={x.itemTypeCode} key={index}>
                  {x.name}
                </option>
              ))}
            </select>
          </span>
        )}
      </div>
      {/* {section.controls.map(item => <ItemEditor key={item.id} form={form} parent={section} item={item} />)} */}
    </div>
  )
}

function ItemEditor({ form, item, provided, removed, data, tabType, index }) {
  const itemStatus = item.find("itemStatus").value; // form.findControl('itemTypeCode', item);
  //console.log(itemStatus, typeof itemStatus)
  function toggleItem() {
    const itemStatus = item.find("itemStatus").value;
    item.find("itemStatus").value = itemStatus === 99 ? 0 : 99;
    form.reset();
  }

  function removeItem() {
    removed(item.id);
  }
  return (
    <div className={`editItem editItem--status-${itemStatus}`}>
      <div className="editItem__controls">
        <div className="handle" {...provided.dragHandleProps}>
          <FaGripLines title="Change order" />
        </div>
        <div className="visibility">
          {itemStatus === 99 ? (
            <FaRegEyeSlash title="Disabled" onClick={() => toggleItem()} />
          ) : (
            <FaRegEye title="Visible" onClick={() => toggleItem()} />
          )}
        </div>
        <div className="delete">
          <FaTrash title="Remove" onClick={() => removeItem()} />
        </div>
      </div>
      <div className="editItem__item">
        {/* {item.id} */}
        <Item
          form={form}
          item={item}
          data={data}
          tabType={tabType}
          index={index}
        />
      </div>
    </div>
  );
}

function Item({ form, item, data, tabType, index }) {
  const render = (name) => form.renderControl(name, item);
  const itemTypeCode = item.find("itemTypeCode").value;
  const linkType = item.find("linkType") && item.find("linkType").value;
  // form.findControl('itemTypeCode', item);
  //console.log(item, itemTypeCode)
  if (itemTypeCode === "video") {
    return (
      <div className="sectionItem row">
        <div className="col-md-5">
          <div>{render("videoUrl")}</div>
          <div>{render("title")}</div>
        </div>
        <div className="col-md-7">{render("desc")}</div>
        {/* {
          (tabType === "howToSection" || tabType === "seeMoreSection") &&
          <div className="col-md-12">{render("auNzCheck")}</div>
        } */}
      </div>
    );
  }
  if (itemTypeCode === "portraitVideo") {
    return (
      <div className="sectionItem row">
        <div className="col-md-5">
          <div>{render("videoUrl")}</div>
          <div>{render("title")}</div>
        </div>
        <div className="col-md-7">{render("desc")}</div>
      </div>
    );
  }
  if (itemTypeCode === "qa") {
    return (
      <div className="sectionItem row">
        <div className="col-12 col-md-4">{render("question")}</div>
        <div className="col-12 col-md-8">{render("answer")}</div>
      </div>
    );
  }
  if (itemTypeCode === "spec") {
    // "{"category": "L","label":"Barrel / Plate size:","text":"19mm Barrel"}"
    return (
      <div className="sectionItem row">
        <div className="col-2">{render("category")}</div>
        <div className="col-10 col-md-5">{render("label")}</div>
        <div className="col-12 col-md-5">{render("text")}</div>
      </div>
    );
  }
  if (itemTypeCode === "link") {
    return (
      <div className="sectionItem row">
        <div className="col-2">{render("linkType")}</div>
        <div className="col-10">{render("title")}</div>
        <div className="col-12">{render("url")}</div>
        {linkType === "instagram" && (
          <div className="col-12">{render("instagramEmbed")}</div>
        )}
        {linkType === "web" && (
          <div className="col-12">
            {render("imageUrl")}
            <ImageSelectorSingle
              form={form}
              menOrWomen={data.menOrWomen}
              fieldName="imageUrl"
              tabType={tabType}
              index={index}
            />
          </div>
        )}

        {
          (tabType === "howToSection" || tabType === "seeMoreSection") &&
          <div className="col-12">{render("auNzCheck")}</div>
        }

      </div>
    );
  }
  if (itemTypeCode === "weblink") {
    return (
      <div className="sectionItem row">
        <div className="col-10">{render("title")}</div>
        <div className="col-12">{render("url")}</div>
        <div className="col-12">{render("auNzCheck")}</div>
      </div>
    );
  }
  return (
    <>
      {render("html")}
      {
        (tabType === "howToSection" || tabType === "seeMoreSection") && render("auNzCheck")
      }
    </>
  );
}

function WordCounter({ form, field, forMeta }) {
  const val = form.getValue()[field];
  const length = (val || '').length;
  // const style = { color: forMeta ? (length < 90 || length > 110 ? 'red' : 'limegreen') : '#666', fontSize: '0.8rem' }
  const style = { color: (length < 90 || length > 110 ? 'red' : 'limegreen'), fontSize: '0.8rem' }
  return <div style={style}>{length} {length === 1 ? 'character' : 'characters'}
    {/* {forMeta && <span style={{ color: '#666', marginLeft: '1rem' }}>(90-110 characters recommended)</span>} */}
    <span style={{ color: '#666', marginLeft: '1rem' }}>(90-110 characters recommended)</span>
  </div>
}
